export function LogoutIcon() {
    return (
      <svg enableBackground="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke="#a12971" strokeWidth="2" transform="translate(5 4)"><path d="m9.7 10.4v3.5c0 1.1-.9 2.1-2.1 2.1h-7.6v-16h7.7c1.1 0 2.1.9 2.1 2.1v3.5" /><path d="m5.6 8h9" /><path d="m11.7 11 2.9-3-2.9-3" /></g></svg>
    );
}